import { Flex, Text } from '@mantine/core';
import FeedbackButton from '@components/sentry-button';

function AppFooter() {
  const currentYear = new Date().getFullYear();

  return (
    <Flex align="center" justify="space-between" pl={20} pr={20} direction="row">
      <FeedbackButton />
      <Text>&copy; {currentYear} Global Thematic Insights &trade; - All Rights Reserved.</Text>
      <Text size="sm" c="gray">
        (mode: {import.meta.env.MODE} &nbsp;&nbsp;&nbsp;build: {import.meta.env.COMMIT_HASH})
      </Text>
    </Flex>
  );
}

export default AppFooter;
